import React, { useState } from 'react';
import BaseModal from '../../../../components/modals/BaseModal';
import { Button, TextField, Box, InputLabel } from '@mui/material';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';
import { ToastType, useToast } from '../../../../context/toast/ToastContext';
import { CloudFunctions } from '../../../../utils/enums/CloudFunctions';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { useOrganizationContext } from '../../../../context/organization_context/OrganizationContext';
import { SketchPicker } from 'react-color';

const EditBrandingModal = ({ show, onHide, accountId }) => {
    const { organization } = useOrganizationContext();
    const [branding, setBranding] = useState({
        businessName: organization.name,
        businessLogo: '',
        businessIcon: '',
        businessPrimaryColor: '',
        businessSecondaryColor: '',
    });
    const { setLoadingData } = useLoadingContext();
    const { showToast } = useToast();
    const { t } = useTranslation();

    const handleInputChange = (field, value) => {
        setBranding({ ...branding, [field]: value });
    };

    const handleLogoUpload = (files) => {
        if (files.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBranding({ ...branding, businessLogo: reader.result });
            };
            reader.readAsDataURL(files[0]);
        }
    };

    const handleIconUpload = (files) => {
        if (files.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBranding({ ...branding, businessIcon: reader.result });
            };
            reader.readAsDataURL(files[0]);
        }
    };

    const handleSaveBranding = async () => {
        setLoadingData(true);
        const functions = getFunctions();
        const updateBranding = httpsCallable(functions, CloudFunctions.UpdateStripeBranding);
        const result = await updateBranding({
            accountId: accountId,
            branding: branding,
        });

        if (result.data.success) {
            showToast(t('success'), ToastType.SUCCESS);
            onHide();
        } else {
            showToast(t('failed'), ToastType.DANGER);
            console.error('Error updating branding:', result.data.error);
        }
        setLoadingData(false);
    };

    const resetForm = () => {
        setBranding({
            businessName: '',
            businessLogo: '',
            businessIcon: '',
            businessPrimaryColor: '',
            businessSecondaryColor: '',
        });
    };

    const actions = (
        <>
            <Button variant="contained" color="primary" onClick={handleSaveBranding}>
                {t(StringKeys.SUBMIT)}
            </Button>
        </>
    );

    return (
        <BaseModal
            open={show}
            onClose={() => {
                resetForm();
                onHide();
            }}
            title="Edit Branding"
            actions={actions}
        >
            <Box p={1}>
                <TextField
                    disabled={true}
                    label={"Business Name"}
                    value={branding.businessName}
                    onChange={(e) => handleInputChange('businessName', e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <Box my={2}>
                    <InputLabel>{"Logo"}</InputLabel>

                </Box>
                <Box my={2}>
                    <InputLabel>{"Icon"}</InputLabel>

                </Box>
                <Box my={2}>
                    <InputLabel>{"Primary Color"}</InputLabel>
                    <SketchPicker
                        color={branding.businessPrimaryColor}
                        onChangeComplete={(color) => handleInputChange('businessPrimaryColor', color.hex)}
                    />
                </Box>
                <Box my={2}>
                    <InputLabel>{"Secondary Color"}</InputLabel>
                    <SketchPicker
                        color={branding.businessSecondaryColor}
                        onChangeComplete={(color) => handleInputChange('businessSecondaryColor', color.hex)}
                    />
                </Box>
            </Box>
        </BaseModal>
    );
};

export default EditBrandingModal;